<template>
  <a href="/" class="logo-link">
    <img
      src="@/assets/new-design/img/logo/logo--dark.svg"
      alt="МТС ЛИНК"
      width="68"
      height="26"
    />
  </a>
</template>

<script>
export default {
  name: "LogoLink",
}
</script>

<style scoped lang="scss">
.logo-link {
  display: block;
}
</style>
